import TabContent0 from "./TabContent0.vue";
import TabContent1 from "./TabContent1.vue";
import TabContent2 from "./TabContent2.vue";

export { TabContent0, TabContent1, TabContent2 };
